import {
  NetworkCoverageMapDataContext
} from "@app/projects/network-assessment/maps/network-coverage-map/contexts/NetworkCoverageMapDataContext";
import {
  ProviderAccordionSelectedTab,
  ProvidersSortOptions,
} from "@app/projects/network-assessment/maps/network-coverage-map/enumerators";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { NewActionMenu, NewActionMenuItem } from "@app/shared/action-menu";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import { JSX, useContext } from "react";

export const ProviderAccordionControlHeader = (): JSX.Element => {

  const mapDataContext = useContext(NetworkCoverageMapDataContext);

  const providersSortOptions = [
    {
      id: 'provider-accordion-sort-alphabetical',
      name: 'Name (A-Z)',
      type: ProvidersSortOptions.Alphabetical,
    },
    {
      id: 'provider-accordion-sort-reverse-alphabetical',
      name: 'Name (Z-A)',
      type: ProvidersSortOptions.ReverseAlphabetical,
    },
    {
      id: 'provider-accordion-sort-serves-high-to-low',
      name: 'Serves % (High to Low)',
      type: ProvidersSortOptions.ServesHighToLow
    },
    {
      id: 'provider-accordion-sort-serves-low-to-high',
      name: 'Serves % (Low to High)',
      type: ProvidersSortOptions.ServesLowToHigh
    },
    {
      id: 'provider-accordion-sort-gains-high-to-low',
      name: 'Gains % (High to Low)',
      type: ProvidersSortOptions.GainsHighToLow,
      visibility: ProviderAccordionSelectedTab.OutOfNetworkProviders
    },
    {
      id: 'provider-accordion-sort-gains-low-to-high',
      name: 'Gains % (Low to High)',
      type: ProvidersSortOptions.GainsLowToHigh,
      visibility: ProviderAccordionSelectedTab.OutOfNetworkProviders
    },
    {
      id: 'provider-accordion-sort-impacts-high-to-low',
      name: 'Impacts % (High to Low)',
      type: ProvidersSortOptions.ImpactsHighToLow,
      visibility: ProviderAccordionSelectedTab.OutOfNetworkProviders
    },
    {
      id: 'provider-accordion-sort-impacts-low-to-high',
      name: 'Impacts % (Low to High)',
      type: ProvidersSortOptions.ImpactsLowToHigh,
      visibility: ProviderAccordionSelectedTab.OutOfNetworkProviders
    }
  ];

  return (
    <div className="network-coverage-map__provider-accordion-header">
      <QESTextInput
        label={'Search'}
        hideLabel
        placeholder="Search by name or NPI"
        testId="network-coverage-map__provider-accordion-search"
        value={mapDataContext.providerSearchText}
        onChange={(e) => mapDataContext.setProviderSearchText(e.target.value)}
        inputAppend={<QesIcon iconName={QesIcons.SearchSm} isDecorative height="15" className="align-text-top" />}
      />
      <div
        className="network-coverage-map__provider-accordion-sort-container"
        style={{
          justifyContent: "space-between",
          width: "100%"
      }}
      >
        <NewActionMenu
          buttonClassNames="qes-button-secondary"
          containerClassnames="network-coverage-map__provider-accordion-sort-container"
          buttonText={
            <>
              <QesIcon
                iconName={QesIcons.SwitchVerticalV1}
                isDecorative
              />&nbsp;
              <span>Sort by</span>
            </>
          }
          testId="network-coverage-map__provider-accordion-sort"
          hideArrow
        >
          {
            providersSortOptions.filter(r => r.visibility == null || r.visibility === mapDataContext.providerAccordionSelectedTab).map((option) => (
              <NewActionMenuItem
                display={option.name}
                key={option.type}
                onClick={() => {
                  mapDataContext.setSelectedSortValue(option.type);
                }}
                isSelected={mapDataContext.getSelectedSortValue() === option.type}
                testId={option.id}
              />
            ))
          }
        </NewActionMenu>
        <div className="label-tiny network-coverage-map__provider-accordion-provider-count">
          { mapDataContext.providerAccordionSelectedTab === ProviderAccordionSelectedTab.NetworkProviders &&
            <>
              Providers: {mapDataContext.visibleAccordionProviders.filter(p => p.providerNetworkType === ProviderNetworkTypeEnum.Network).length} of {mapDataContext.networkProviderCount}
            </>
          }
          { mapDataContext.providerAccordionSelectedTab === ProviderAccordionSelectedTab.OutOfNetworkProviders &&
            <>
              Providers: {mapDataContext.visibleAccordionProviders.filter(p => p.providerNetworkType !== ProviderNetworkTypeEnum.Network).length} of {mapDataContext.impactProviderCount}
            </>
          }
          <TooltipWrapper
            text="Displays the number of providers that match your current filters and view out of the total available"
            position="right"
            containerClassName="ms-2"
            tooltipWidth="20rem"
          >
            <QesIcon
              iconName={QesIcons.InfoCircle}
              color="#828282"
              height="16px"
              width="16px"
              description="Tooltip"
              className="mb-1"
            />
          </TooltipWrapper>
        </div>
      </div>
    </div>
  )
}